import { render } from "./VerFormatoImportaciones.vue?vue&type=template&id=270697a3&scoped=true"
import script from "./VerFormatoImportaciones.vue?vue&type=script&lang=js"
export * from "./VerFormatoImportaciones.vue?vue&type=script&lang=js"

import "./VerFormatoImportaciones.vue?vue&type=style&index=0&id=270697a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270697a3"]])

export default __exports__